import React from 'react';
import { Grid, makeStyles, Tab, Tabs, Typography, Box, Button, CircularProgress } from '@material-ui/core';
import PrismCode from "react-prism";
import "prismjs";
import "prismjs/components/prism-jsx.min";
import "prismjs/themes/prism-okaidia.css";
import 'prismjs/plugins/line-numbers/prism-line-numbers.js'
import { AuthContext } from '../../../contexts';
import { Code } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        background: '#272730',
        width: '48%',
        bottom: 80,
        position: 'fixed',
        left: '32%',
        zIndex: 1000,
        borderRadius: 20
    },
    content: {
        // minHeight: 40,
        // maxHeight: 360,
        height: 360,
        overflowY: 'auto',
        overflowX: 'auto',
        paddingRight: 20
    },
    tabHead: {
        "& .MuiButtonBase-root": {
            borderColor: "#fff !important",
        }
    },
    copyButton: {
        backgroundColor: '#56821C',
        position: 'absolute',
        right: 10,
        top: 10,
        fontSize: 12,
        color: '#fff',
        cursor: 'pointer',
        zIndex: 1001
    },
    tabTitle: {
        color: '#fff',
        textTransform: "initial"
    },
    progressLoader: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '80px',
        "& .MuiCircularProgress-root": {
            color: "#a57e29"
        }
    }
}))

const code = `
<Row key={\"0\"}>\n  <Col\n    key={\"0\"}\n    name={\"qdm-col-12\"}\n    alignItems={\"stretch\"}\n    direction={\"row\"}\n    justify={\"flex-start\"}\n    textAlign={\"left\"}\n    lg={\"6\"}\n    xs={\"12\"}\n    md={\"12\"}\n    sm={\"12\"}\n  >\n    <TextInput\n      key={\"0\"}\n      type={\"text\"}\n      name={t(\"text\")}\n      variant={\"outlined\"}\n      helperTextType={\"error\"}\n      label={t(\"username\")}\n      autoFocus={false}\n      autoComplete={\"off\"}\n      search={false}\n      borderColor={\"#9b9b9b\"}\n      elevation={\"0\"}\n      placeholder={\"text field\"}\n      size={\"medium\"}\n      isRequired={false}\n      required={false}\n      hoverColor={\"#000\"}\n      dateIcon={\"\"}\n      maxLength={\"100\"}\n      iconText={\"\"}\n      minLength={\"100\"}\n    ></TextInput>\n  </Col>\n  <Col\n    key={\"1\"}\n    name={\"qdm-col-12\"}\n    alignItems={\"stretch\"}\n    direction={\"row\"}\n    justify={\"flex-start\"}\n    textAlign={\"left\"}\n    lg={\"6\"}\n    xs={\"12\"}\n    md={\"12\"}\n    sm={\"12\"}\n  >\n    <TextInput\n      key={\"0\"}\n      type={\"text\"}\n      name={t(\"text\")}\n      variant={\"outlined\"}\n      helperTextType={\"error\"}\n      label={t(\"password\")}\n      autoFocus={false}\n      autoComplete={\"off\"}\n      search={false}\n      borderColor={\"#9b9b9b\"}\n      elevation={\"0\"}\n      placeholder={\"text field\"}\n      size={\"medium\"}\n      isRequired={false}\n      required={false}\n      hoverColor={\"#000\"}\n      dateIcon={\"\"}\n      maxLength={\"100\"}\n      iconText={\"\"}\n      minLength={\"100\"}\n    ></TextInput>\n  </Col>\n  <Col\n    key={\"2\"}\n    name={\"qdm-col-12\"}\n    alignItems={\"stretch\"}\n    direction={\"row\"}\n    justify={\"flex-start\"}\n    textAlign={\"left\"}\n    lg={\"6\"}\n    xs={\"12\"}\n    md={\"12\"}\n    sm={\"12\"}\n  >\n    <TextInput\n      key={\"0\"}\n      type={\"text\"}\n      name={t(\"text\")}\n      variant={\"outlined\"}\n      helperTextType={\"error\"}\n      label={t(\"Email\")}\n      autoFocus={false}\n      autoComplete={\"off\"}\n      search={false}\n      borderColor={\"#9b9b9b\"}\n      elevation={\"0\"}\n      placeholder={\"text field\"}\n      size={\"medium\"}\n      isRequired={false}\n      required={false}\n      hoverColor={\"#000\"}\n      dateIcon={\"\"}\n      maxLength={\"100\"}\n      iconText={\"\"}\n      minLength={\"100\"}\n    ></TextInput>\n  </Col>\n  <Col\n    key={\"3\"}\n    name={\"qdm-col-12\"}\n    alignItems={\"stretch\"}\n    direction={\"row\"}\n    justify={\"flex-start\"}\n    textAlign={\"left\"}\n    lg={\"12\"}\n    xs={\"12\"}\n    md={\"12\"}\n    sm={\"12\"}\n    style={qdmstyles.cOwv}\n  >\n    <Radio\n      key={\"0\"}\n      size={\"medium\"}\n      color={\"primary\"}\n      label={t(\"Male\")}\n      defaultChecked={false}\n      indeterminate={false}\n    ></Radio>\n    <Radio\n      key={\"1\"}\n      size={\"medium\"}\n      color={\"primary\"}\n      label={t(\"Female\")}\n      defaultChecked={false}\n      indeterminate={false}\n    ></Radio>\n  </Col>\n  <Col\n    key={\"4\"}\n    name={\"qdm-col-12\"}\n    alignItems={\"stretch\"}\n    direction={\"row\"}\n    justify={\"flex-end\"}\n    textAlign={\"left\"}\n    lg={\"12\"}\n    xs={\"12\"}\n    md={\"12\"}\n    sm={\"12\"}\n  >\n    <Button\n      key={\"0\"}\n      type={\"button\"}\n      variant={\"outlined\"}\n      name={t(\"Submit\")}\n      style={qdmstyles.cXJX}\n    ></Button>\n  </Col>\n</Row>;\n
`;


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CodePanel(props) {
    const classes = useStyles();
    const [formatted, setFormatted] = React.useState("")
    const [metaData, setMetaData] = React.useState({})
    const auth = React.useContext(AuthContext);
    const [value, setValue] = React.useState(0);

    React.useEffect(() => {

        if (auth.user?.codePanel?.sourceCode) {
            let formatted = auth.user?.codePanel?.sourceCode?.split('\n')
                .map((line, num) => `${(num + 1).toString().padStart(2, ' ')}. ${line}`)
                .join('\n');
            setFormatted(formatted)

            let metaData = JSON.stringify(auth.user?.codePanel?.metaData, null, "\t")?.split('\n')
                .map((line, num) => `${(num + 1).toString().padStart(2, ' ')}. ${line}`)
                .join('\n');
            setMetaData(metaData)
        }

    }, [auth.user?.codePanel?.sourceCode])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Button
                className={classes.copyButton}
                variant="contained"
                size="small"
                onClick={() => {
                    if (value === 0) navigator.clipboard.writeText(JSON.stringify(auth.user?.codePanel?.metaData, null, '\t'));
                    else navigator.clipboard.writeText(auth.user?.codePanel?.sourceCode);
                }}
                disableFocusRipple
                disableRipple
            >
                Copy
            </Button>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        className={classes.tabHead}
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#fff"
                            }
                        }}
                    >
                        <Tab className={classes.tabTitle} label="Meta Data" {...a11yProps(0)} />
                        <Tab className={classes.tabTitle} label="Source Code" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0} className={classes.content}>
                    {
                        auth.user?.codePanel?.metaData && !auth.user?.codePanel?.loading ? <PrismCode
                            className="language-javascript"
                            children={JSON.stringify(auth.user?.codePanel?.metaData, null, "\t")}
                        /> : <div className={classes.progressLoader}>
                            <CircularProgress />
                        </div>
                    }
                </TabPanel>
                <TabPanel value={value} index={1} className={classes.content}>
                    {
                        formatted && !auth.user?.codePanel?.loading ? <PrismCode
                            className="language-jsx"
                            children={formatted}
                        /> : <CircularProgress />
                    }
                </TabPanel>
            </Box>
        </div>
    )
}